import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { claimdashboardreturnBO } from './operational-dashboard.modal';

@Injectable({
  providedIn: 'root'
})

export class operationalclaimservice {
    constructor(private http: HttpClient, public errorService: ErrorService) { }

    getclaim(list:any):Observable<any>
    {
  
    let url = "api/Claims/getActiveandArchiveClaimAmountandCount?";
    return  this.http.post<claimdashboardreturnBO>(url,list,{observe :'response'}).pipe(
    map(data => data.body ),
    catchError(this.errorService.handleError)
    );
    }

}